import React from 'react';
import { BasicCollapse, TextAreaFieldItem } from 'ui-lib';
import { IConfigureStepProps } from '../component-version-wizard.types';
import { ArtifactsPickerFormItem } from '../../artifacts-picker';
import css from '../../raptor-components.css';

export const CatapultConfigureStep = (props: IConfigureStepProps): JSX.Element => {
    return (
        <React.Fragment>
            <TextAreaFieldItem
                code='configurationJson'
                label='Configuration JSON'
                textAreaProps={{ autoSize: { minRows: 6, maxRows: 12 }, placeholder: '{}' }}
            />
            <BasicCollapse
                className={css['manifest-panel']}
                key={props.selectedPlatforms.map((platform) => platform.uuid).join('|')}
                defaultActiveKey={props.selectedPlatforms.map((platform) => platform.uuid)}
                panels={props.selectedPlatforms.map((platform) => ({
                    key: platform.uuid,
                    header: platform.displayName,
                    content: (
                        <React.Fragment>
                            <TextAreaFieldItem
                                labelAlign='right'
                                code={`install-${platform.uuid}`}
                                name={['manifests', platform.uuid, 'lifecycle', 'install']}
                                label='Install'
                                textAreaProps={{ autoSize: { minRows: 2, maxRows: 6 } }}
                            />
                            <TextAreaFieldItem
                                labelAlign='right'
                                code={`run-${platform.uuid}`}
                                name={['manifests', platform.uuid, 'lifecycle', 'run']}
                                label='Run'
                                textAreaProps={{ autoSize: { minRows: 2, maxRows: 6 } }}
                            />
                            <TextAreaFieldItem
                                labelAlign='right'
                                code={`startup-${platform.uuid}`}
                                name={['manifests', platform.uuid, 'lifecycle', 'startup']}
                                label='Startup'
                                textAreaProps={{ autoSize: { minRows: 2, maxRows: 6 } }}
                            />
                            <ArtifactsPickerFormItem
                                name={['manifests', platform.uuid, 'uploadedFiles']}
                                label='Artifacts'
                                selectionType='multiple'
                                accountUuid={props.accountUuid}
                                source={props.artifactsSource}
                            />
                        </React.Fragment>
                    ),
                }))}
            />
        </React.Fragment>
    );
};
